import api from "../../api";
import type { SurveysApiResponse } from "../../../@types/portalAluno";
import { mapSurveysResponse } from "../../../utils/portalAluno/mappers/surveysMapper";

export const getSurveys = async () => {
  const response = await api.get<SurveysApiResponse>(
    "mobile/enquetesPesquisas"
  );

  return mapSurveysResponse(response.data);
};
